import React from 'react';
import ReactDOM from 'react-dom';

import { init as sentryInit } from 'utils/sentry';
import { isDevEnvironment } from 'config';
import process from 'process';
import { Buffer } from 'buffer';
import { reloadOnceForDynamicImportError } from 'utils/dynamicImportError';

import {
  init as httpInit,
  initHotJar,
  initProdConsoleGuard,
} from './utils/initializers';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

initProdConsoleGuard();
httpInit();
sentryInit();

window.process = process;
window.Buffer = Buffer;

// Vite fires this on `window` when a modulepreload for a route chunk fails
// (e.g. this tab has been open since before the latest deploy, and the
// hashed chunk filename it wants no longer exists). This happens outside
// any component's render path, so no ErrorBoundary can catch it - reload
// once to pick up the current build instead of leaving the tab stuck.
window.addEventListener('vite:preloadError', (event) => {
  if (reloadOnceForDynamicImportError(event.payload)) {
    event.preventDefault();
  }
});

if (isDevEnvironment) {
  // gaInit();
  // gtmInit();
  initHotJar();
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
